<template>
  <div>
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @submitDel="del"
    >
      <div slot="header">
        <b-button
          class="mr-2"
          size="sm"
          :disabled="disabled"
          variant="outline-success"
          @click="() => (orderGoodsDialogVisible = true)"
          >{{ $l('goods_package_add_goods') || '添加产品' }}
        </b-button>
        <b-button
          class="mr-2"
          size="sm"
          :disabled="disabled"
          variant="outline-danger"
          @click="batchDel()"
        >
          <i class="el-icon-delete" />
          {{ $l('INDEX.btn_delete') || '删除' }}
        </b-button>
      </div>
    </Main>
    <ChooseOrderGoodsDialog
      :title="
        $l('INDEX.order_goods_label_orderGoods_information') || '订单产品信息'
      "
      :visible.sync="orderGoodsDialogVisible"
      type="checkbox"
      :orderCode="orderCode"
      @confirm="orderGoodsConfirm"
    />
  </div>
</template>
<script>
import Main from './main'
import EditLoading from '@/mixins/edit-loading'
import ChooseOrderGoodsDialog from '@/views/factory/components/choose-order-goods/dialog.vue'
export default {
  mixins: [EditLoading],
  components: { Main, ChooseOrderGoodsDialog },
  props: {
    orderCode: { type: String, default: '' },
    orderGoodsPackageDocCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    isExpand: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      orderGoodsDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderGoodsPackageDocCode) return
      this.loading = true
      this.$api
        .orderGoodsPackageDocGoodsListApi({
          orderGoodsPackageDocCode: this.orderGoodsPackageDocCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    orderGoodsConfirm(data) {
      if (this.isExpand) {
        this.addDBData(data)
        return
      }
      this.addTableData(data)
    },
    addDBData(data) {
      const listOrderGoodsCode = data
        .map((i) => i.orderGoodsCode)
        .filter(
          (i) => this.tableData.findIndex((j) => j.orderGoodsCode === i) < 0
        )

      if (listOrderGoodsCode.length !== data.length) {
        this.$message(
          this.$l('inspection_choose_goods_repeat_tips') ||
            '已为您过滤掉重复的产品信息！'
        )
      }

      if (!listOrderGoodsCode || !listOrderGoodsCode.length) return

      const params = {
        orderGoodsPackageDocCode: this.orderGoodsPackageDocCode,
        listOrderGoodsCode,
      }

      this.loadingOpen()
      this.$api
        .orderGoodsPackageDocGoodsBatchAddApi(params)
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.getData()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    addTableData(data) {
      if (!data || !data.length) return
      const tableData = data
        .map((i) => {
          return {
            orderGoodsCode: i.orderGoodsCode,
            orderGoodsNo: i.orderGoodsNo,
            identifyGoodsNo: i.identifyGoodsNo,
            orderGoodsDisplayName: i.orderGoodsDisplayName,
          }
        })
        .filter(
          (i) =>
            this.tableData.findIndex(
              (j) => j.orderGoodsCode === i.orderGoodsCode
            ) < 0
        )
      this.tableData.push(...tableData)
    },
    batchDel() {
      const delRows = this.$refs.tableMain.getCheckboxRecords()
      if (!delRows || !delRows.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }

      const listCode = delRows.map((i) => i.orderGoodsCode)
      this.del(listCode)
    },
    del(listCode) {
      const delRow = this.tableData.filter(
        (i) => listCode.findIndex((j) => i.orderGoodsCode === j) >= 0
      )
      if (this.isExpand) {
        this.delDBData(delRow)
        return
      }
      this.delTableData(delRow)
    },
    delDBData(delRows) {
      const listGoodsCode = delRows.map((i) => i.orderGoodsPackageDocGoodsCode)
      const dataCount = this.tableData.length || 0

      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .orderGoodsPackageDocGoodsBatchDelApi({ listGoodsCode })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(
                this.$l('INDEX.tips_delete_no') || '删除失败！'
              )
              return
            }
            this.$message({
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getData()
            if (listGoodsCode.length >= dataCount) this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    delTableData(delRows) {
      const tableData = this.tableData.filter(
        (i) =>
          delRows.findIndex((j) => i.orderGoodsCode == j.orderGoodsCode) < 0
      )
      this.tableData = [...tableData]
    },
    getTableData() {
      return this.tableData
    },
  },
}
</script>
